













































































import Vue from 'vue';
import * as avvocatoApi from '../../services/avvocato-api';
import { AvvocatoEditViewModel } from '../../types';
import validationRulesMixin from '../../components/mixin/validation-rules-mixin';

export default Vue.extend({
    mixins: [validationRulesMixin],

    components: {},
    props: {
        fullSize: { default: false },
        id: { default: 0 },
    },
    data(): AvvocatoEditViewModel {
        return {
            item: null,
            isValid: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.item != null && this.item.id === 0;
        },
    },
    methods: {
        async loadData(id: number): Promise<void> {
            if (id > 0) {
                this.item = await avvocatoApi.getByKey(id);
            } else {
                this.setNewItem();
            }
        },
        close() {
            this.$emit('close');
        },
        setNewItem() {
            this.item = {
                id: 0,
                version: 0,
                email: '',
                nome: '',
                cognome: '',
                attivo: true,
                displayName: this.$i18n.t('labels.nuovo').toString(),
            };
        },
        async save() {
            if (!this.item) {
                return;
            }
            let response = null;
            if (this.isNew) {
                response = await avvocatoApi.create({
                    nome: this.item.nome,
                    cognome: this.item.cognome,
                    email: this.item.email,
                });
            } else {
                response = await avvocatoApi.update({
                    id: this.item.id,
                    version: this.item.version,
                    nome: this.item.nome,
                    cognome: this.item.cognome,
                    email: this.item.email,
                    attivo: this.item.attivo,
                });
            }
            await this.loadData(response.id);
            this.$emit('save', this.item);
        },
    },
    async mounted() {
        await this.loadData(this.id);
        setTimeout(() => {
            this.isValid = (this.$refs.form as HTMLFormElement).validate();
        });
    },
});
